import React, { ReactNode } from "react";
import { PagesProgressProvider } from "@bprogress/next";

// Props interface with same API as the original nextjs-progressbar
interface NavigationProgressbarPropsI {
  color?: string;
  options?: {
    showSpinner?: boolean;
    [key: string]: any;
  };
  showOnShallow?: boolean;
  height?: string | number;
  children: ReactNode;
  [key: string]: any;
}

/**
 * NavigationProgressbar provider component using @bprogress/next for pages router
 *
 * Usage: Wrap your app content with this provider in _app.tsx:
 * <NavigationProgressbar>{pageContent}</NavigationProgressbar>
 */
const NavigationProgressbar = ({
  color = "rgb(15, 53, 255)",
  options = { showSpinner: false },
  showOnShallow = false,
  height = "4px",
  children,
  ...props
}: NavigationProgressbarPropsI) => {
  return (
    <PagesProgressProvider
      height={typeof height === "number" ? `${height}px` : height}
      color={color}
      options={options}
      shallowRouting={showOnShallow}
      {...props}
    >
      {children}
    </PagesProgressProvider>
  );
};

export default NavigationProgressbar;
